module.exports = __webpack_public_path__ + "img/ticon2.a4c1d09a.png";